"use client";
import Image from "next/image";
import { ConvertDate } from "../../../../utils/ConvertDate";

function BlogCard({
  blog = {
    title: "Default Blog Title",
    image: "/path/to/default-image.jpg",
    description: "This is a default description for the blog card.",
    date: new Date().toISOString(),
  },
}) {
  return (
    <article className="border border-white/10 hover:border-violet-500/40 transition-all duration-500 bg-neutral-950/60 rounded-2xl overflow-hidden">
      <div className="overflow-hidden h-56">
        <Image
          src={blog.image}
          alt={blog.title || "Blog Image"}
          width={600}
          height={400}
          className="h-full w-full hover:scale-105 transition-all duration-300 object-cover"
        />
      </div>
      <div className="px-5 py-4">
        <p className="text-xs text-violet-300 mb-2">{ConvertDate(blog.date)}</p>
        <h3 className="text-lg font-semibold text-white">{blog.title}</h3>
        <p className="text-sm text-neutral-400 mt-2">{blog.description}</p>
      </div>
    </article>
  );
}

export default BlogCard;
